// extracted by mini-css-extract-plugin
module.exports = {"header":"ProposalHeader_header__1cRBu","meta":"ProposalHeader_meta__2LFiG","title":"ProposalHeader_title__EeQ2d","date":"ProposalHeader_date__1obeb"};